import { IStorageItem } from '_data/types/project';
import { isNullable } from '_helpers/nullable';

export interface ISelectedStorageItemsSet extends Pick<Set<IStorageItem>, 'clear' | 'size'> {
  add(newStorageItem: IStorageItem): this;
  [Symbol.iterator](): IterableIterator<IStorageItem>;
  has(id: number): boolean;
  delete(id: number): boolean;
}

export default class SelectedStorageItemsSet implements ISelectedStorageItemsSet {
  private map: Map<IStorageItem['id'], IStorageItem>;

  constructor(input?: IStorageItem[] | ISelectedStorageItemsSet) {
    if (isNullable(input)) {
      this.map = new Map();
    } else {
      this.map = new Map(
        Object.entries(
          [...input].reduce(
            (result, item) => ({
              ...result,
              ...(isNullable(result[item.id]) ? { [item.id]: item } : undefined),
            }),
            {}
          )
        ).map(([key, value]: [string, IStorageItem]) => [Number(key), value])
      );
    }
  }

  [Symbol.iterator](): IterableIterator<IStorageItem> {
    return this.map.values();
  }

  add(newStorageItem: IStorageItem) {
    this.map.set(newStorageItem.id, newStorageItem);

    return this;
  }

  delete(id: number) {
    return this.map.delete(id);
  }

  clear() {
    this.map.clear();
  }

  has(id: number) {
    return this.map.has(id);
  }

  get size() {
    return this.map.size;
  }
}
